export enum CouponStatus {
    notRealized = 1,
    realized,
    expired
}